import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero" id="home">
      <div className="hero__bg-pattern" aria-hidden="true">
        {Array.from({ length: 80 }).map((_, i) => (
          <span key={i} className="hero__diamond" />
        ))}
      </div>

      <div className="hero__content">
        <p className="hero__eyebrow">THE LINE OF EFFICIENCY</p>
        <h1 className="hero__heading">
          <span className="hero__heading-black">Solving Problems</span>
          <span className="hero__heading-italic">One Ascent at a<br />Time.</span>
        </h1>
        <p className="hero__sub">
          Software Engineer &amp; Rock Climber. Applying the precision of<br />
          code to the vertical world.
        </p>
        <div className="hero__actions">
          <a href="#projects" className="hero__btn hero__btn--primary">View Routes</a>
          <a href="#about" className="hero__btn hero__btn--ghost">The Profile</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
